import {
  ImportExamineeAnswersButton,
  useExamEventDetails,
} from '@exam-center/exam-event-management';
import { ExamEventStatus, ExamGradingStatus } from '@exam-center/graphql';
import { useNavigate, useParams } from '@exam-center/router';
import { Box, Button, PaperSection, Text } from '@shared/components';

import { ExamEventExamineeResultBanner } from '../exam-event-examinee-result-banner';
import { ExamEventExamineeResultList } from '../exam-event-examinee-result-list';

export default function ExamEventExamineeResultSection() {
  const {
    examEvent: {
      id: examEventId,
      status,
      metadata: { examGradingStatus },
    },
  } = useExamEventDetails();

  const navigate = useNavigate();

  const { examCenterCode } = useParams('/:examCenterCode/exam-events/:examEventId/results');

  return (
    <PaperSection
      title='รายชื่อผู้มีสิทธิสอบ'
      endAdornment={
        status === ExamEventStatus.Completed ? (
          <Button
            onClick={() => {
              navigate('/:examCenterCode/exam-events/:examEventId/score-report', {
                params: {
                  examCenterCode,
                  examEventId,
                },
              });
            }}
          >
            สรุปผลการสอบ
          </Button>
        ) : examGradingStatus ? (
          <ImportExamineeAnswersButton
            tooltipText={
              <Text variant='captionSemibold'>
                ไม่สามารถตรวจข้อสอบได้
                <br />
                เนื่องจากระบบกำลังตรวจข้อสอบอยู่
              </Text>
            }
            disabled={examGradingStatus === ExamGradingStatus.InProgress}
            examEventId={examEventId}
          />
        ) : null
      }
    >
      <ExamEventExamineeResultBanner />
      <Box sx={(theme) => ({ p: theme.spacing(6) })}>
        <ExamEventExamineeResultList />
      </Box>
    </PaperSection>
  );
}
